export default __webpack_public_path__ + "static/media/room-4.10d2e64a.jpeg";